import React from "react";
import { Outlet} from "react-router-dom";
import "./Layout.css"
import Header from "./Header";

const Layout = () => (
    <div className="layout">
        <Header />
        <div className="content">
            <Outlet />
        </div>
    </div>
);

export default Layout;